import { leafLabel } from "./kindWords";

export const pathLabel = (labelOf: (path: string) => string, path: string) => {
  const named = labelOf(path);
  return named === path ? leafLabel(path.split(".").pop() ?? path) : named;
};
